import {HttpClient} from "../../service/httpClient/HttpClient";
import {dateIsNotValid} from "../../util/VariableChecker";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class AccountTransactionsService {
    constructor() {
        this.httpClient = new HttpClient();
    }


    getAccountTransactionsByAccountId(fundId, id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundId}/monthly-deposits`,
                {
                    "deposit-account-id": id,
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewTransaction(fundID, accountId, amount, date) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/deposit-accounts/${accountId}/monthly-deposits`,
                {
                    amount,
                    depositedAt: date
                }
            ).then(resolve).catch(reject)
        })
    }

    getAccountTransactionInfo(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/monthly-deposits/${id}`
            ).then(resolve).catch(reject)
        })
    }

    handleUpdateTransaction(fundID, id, amount, date) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/monthly-deposits/${id}`,
                {
                    depositedAt: date,
                    amount: amount ? amount : "0",
                    enabled: amount && amount.toString().length > 0 && parseInt(amount) !== 0
                }
            ).then(resolve).catch(reject)
        })
    }

    getAccountTransactions(
        fundId,
        page,
        size,
        filterFullName,
        filterNationalCode,
        filterGroupName,
        filterAccountCode,
        filterGroupCode,
        payAt,
        submitAt,
        filterPayerType) {


        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundId}/monthly-deposits`,
                {
                    page, size,
                    "owner-full-name": filterFullName,
                    "owner-national-code": filterNationalCode,
                    "deposit-account-number": filterAccountCode >= 0 ? filterAccountCode : null,
                    "group-name": filterGroupName,
                    "groupCode": filterGroupCode >= 0 ? filterGroupCode : null,
                    "depositor-type": filterPayerType !== "ALL" ? filterPayerType : null,
                    "deposited-at": dateIsNotValid(payAt) ? null : payAt,
                    "submitted-at": dateIsNotValid(submitAt) ? null : submitAt,
                }
            ).then(resolve).catch(reject)
        })

    }

    getPayableAccounts(fundId, groupId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundId}/groups/${groupId}/deposit-accounts`
            ).then(resolve).catch(reject)
        })
    }

    addNewGroupPay(fundID, groupId, transactions) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/groups/${groupId}/monthly-deposits`,
                transactions
            ).then(resolve).catch(reject)
        })
    }

    getPayableAccountsForUpdateDeposit(fundID, groupId, date) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/groups/${groupId}/monthly-deposits/deposited-at/${date}`
            ).then(resolve).catch(reject)
        })
    }

    updateMonthlyDepositTransactions(fundID, transactions) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/monthly-deposits`,
                transactions
            ).then(resolve).catch(reject)
        })
    }
}